<div class="full-page-background">

</div>

<div class="contenedor">
    <img src="https://iteck.themescamp.com/app/wp-content/uploads/sites/3/2022/04/header_4_wave.png" alt="Imagen" class="floating-image">
</div>


<div class="background">
    <img src="https://iteck.themescamp.com/app/wp-content/uploads/sites/3/2022/04/header_4_bubble.png" alt="Imagen" class="rotating-image">
</div>

<div class="container my-component">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-2 col-sm-3 col-6 pt-4 pb-4 d-flex align-items-center">
                <!-- Utiliza col-6 en lugar de col-xs-6 -->
                <img src="../../../assets/img/Logo Reda.png" alt="logo" class="img-fluid" />
            </div>
        </div>

        <div class="card col-12">
            <div class="card-body">
                <h2 style="font-weight: bold;">Registra tu proyecto</h2>
                <p style="font-size: 16px;">Para registrar tu proyecto, por favor completa los siguientes pasos.</p>
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header" style="max-height: 400; overflow-y: auto;" #stepperContainer>
                        <div class="step" data-target="#test-l-0">
                            <button class="step-trigger">
                                <span [ngStyle]="{'background-color':step0 ? '#88be1c' : null}"
                                    class="bs-stepper-circle"><i
                                        [ngClass]="{'simple-icon-user':!step0, 'simple-icon-check':step0}"></i></span>
                                <span class="bs-stepper-label"
                                    [ngStyle]="{'color':step0 ? '#88be1c' : null}">Usuario</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#test-l-1">
                            <button class="step-trigger" [disabled]="!step0 || disabledEmpresa">
                                <span [ngStyle]="{'background-color':step1 ? '#88be1c' : null}"
                                    class="bs-stepper-circle"><i
                                        [ngClass]="{'simple-icon-settings':!step1, 'simple-icon-check':step1}"></i></span>
                                <span class="bs-stepper-label"
                                    [ngStyle]="{'color':step1 ? '#88be1c' : null}">Desarrolladora</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#test-l-2">
                            <button class="step-trigger" [disabled]="!step1">
                                <span [ngStyle]="{'background-color':step2 ? '#88be1c' : null}"
                                    class="bs-stepper-circle"><i
                                        [ngClass]="{'iconsminds-home':!step2, 'simple-icon-check':step2}"></i></span>
                                <span class="bs-stepper-label"
                                    [ngStyle]="{'color':step2 ? '#88be1c' : null}">Proyecto</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#test-l-3">
                            <button class="step-trigger" [disabled]="!step2">
                                <span [ngStyle]="{'background-color':step3 ? '#88be1c' : null}"
                                    class="bs-stepper-circle"><i
                                        [ngClass]="{'simple-icon-layers':!step3, 'simple-icon-check':step3}"></i></span>
                                <span class="bs-stepper-label"
                                    [ngStyle]="{'color':step3 ? '#88be1c' : null}">Modelos</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#test-l-4">
                            <button class="step-trigger" [disabled]="!step3">
                                <span [ngStyle]="{'background-color':step4 ? '#88be1c' : null}"
                                    class="bs-stepper-circle"><i
                                        [ngClass]="{'simple-icon-star':!step4, 'simple-icon-check':step4}"></i></span>
                                <span class="bs-stepper-label"
                                    [ngStyle]="{'color':step4 ? '#88be1c' : null}">Amenidades</span>
                            </button>
                        </div>
                    </div>
                    <div class="bs-stepper-content">
                        <div id="test-l-0" class="content">
                            <div class="row pt-4">
                                <div class="col-md-8 offset-md-2 ">
                                    <div class="row">
                                        <h2 style="font-weight: bold;">Déjanos tu información de contacto</h2>
                                        <p>Déjanos tus detalles de contacto para que podamos ponernos en contacto contigo de manera efectiva. Agradecemos tu disposición a mantener una comunicación fluida y poder ofrecerte la asistencia o información que
                                            necesites.
                                        </p>
                                        <br>
                                        <div class="col-md-12 col-sm-12">
                                            <div class="row">
                                                <div class="col-md-6  d-none d-md-block" style="text-align: right; ">
                                                    <img style="width: 100%;" src="../../../assets/img/NuevoUsuario.png" alt="">
                                                </div>
                                                <div class="col-md-6">
                                                    <form [formGroup]="formUsuario" #formU="ngForm" (ngSubmit)="guardaUsuario(empresaModal)" novalidate>

                                                        <div class="form-group">
                                                            <label>Nombre</label>
                                                            <input type="text" class="form-control input-style" placeholder="Ingresa tu nombre" formControlName="nombre" />
                                                        </div>

                                                        <div class="form-group">
                                                            <label>Teléfono</label>
                                                            <ngx-intl-tel-input [cssClass]="'custom form-control mb-0'" style="width: 100%;" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                                                [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.Mexico" [maxLength]="10" [phoneValidation]="true" [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National"
                                                                name="telefono" formControlName="telefono">
                                                            </ngx-intl-tel-input>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Correo</label>
                                                            <input type="email" class="form-control input-style" placeholder="Correo electrónico" formControlName="correo" />
                                                        </div>
                                                    </form>
                                                </div>

                                            </div>
                                            <br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="test-l-1" class="content">
                            <div class="row pt-4">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-8 offset-md-2 col-sm-12">
                                            <h2 style="font-weight: bold;">Datos de la desarrolladora</h2>
                                            <p>Completa este formulario con los siguientes detalles clave sobre tu empresa desarrolladora. Nos ayudará a conocer mejor tu perfil y experiencia en el mercado para brindarte oportunidades y apoyo adecuados.
                                            </p>
                                            <br>
                                            <form [formGroup]="formDesarrolladora" #formD="ngForm" (ngSubmit)="guardaDesarrolladora()" novalidate>
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12 col-lg-3 pb-3">
                                                        <label>Logotipo</label>
                                                        <div *ngIf="!existeImagen" (click)="fileLogotipo.click()" class="container-click">
                                                            <div class="icon-container">
                                                                <i style="font-size: 20px;" class="simple-icon-picture"></i>
                                                            </div>
                                                        </div>


                                                        <div *ngIf="existeImagen" class="contenedor-img">
                                                            <img class="logo-img pl-1" [src]="imagenUrl" alt="logo">
                                                            <i class="fas fa-times delete-icon" (click)="clearImagen()"></i>
                                                        </div>
                                                        <input accept="image/png, image/jpg, image/jpeg" #fileLogotipo (change)="uploadImagen($event)" type="file" name="logo-input" hidden>
                                                    </div>

                                                    <div class="col-sm-12 col-md-12 col-lg-9">
                                                        <label>Nombre</label>
                                                        <input type="text" class="form-control input-style" placeholder="Nombre" formControlName="nombre" />
                                                        <br>
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <label>Cantidad de proyectos</label>
                                                                <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="proyectos" />
                                                            </div>
                                                            <div class="col-6">
                                                                <label>Años de experiencia</label>
                                                                <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="experiencia" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </form>

                                            <br>
                                            <label>Ubicación</label>
                                            <div class="form-group">
                                                <input placeholder="Busca la dirección" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" class="form-control input-style" #search [formControl]="searchControl">
                                            </div>
                                            <agm-map [latitude]="latitude" [styles]="mapStyles" [longitude]="longitude" [scrollwheel]="false" [zoom]="zoom">
                                                <agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>
                                            </agm-map>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="test-l-2" class="content">
                            <div class="row pt-4">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-8 offset-md-2 col-sm-12">
                                            <h2 style="font-weight: bold;">Datos de tu proyecto</h2>
                                            <p>Queremos conocer todos los aspectos importantes de tu proyecto. Por favor, proporciona la información solicitada para que podamos entender su alcance y particularidades. Tu colaboración es clave para ofrecerte
                                                el mejor apoyo y asesoramiento.</p>
                                            <br>
                                            <form [formGroup]="formProyecto" #formP="ngForm" (ngSubmit)="guardaProyecto()" novalidate>
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12 col-lg-3 pb-3">
                                                        <label>Logotipo</label>

                                                        <div *ngIf="!existeLogoP" (click)="fileLogotipoP.click()" class="container-click">
                                                            <div class="icon-container">
                                                                <i style="font-size: 20px;" class="simple-icon-picture"></i>
                                                            </div>
                                                        </div>



                                                        <div *ngIf="existeLogoP" class="contenedor-img">
                                                            <img class="logo-img pl-1" [src]="logoPUrl" alt="logo">
                                                            <i class="fas fa-times delete-icon" (click)="clearLogoP()"></i>
                                                        </div>
                                                        <input accept="image/png, image/jpg, image/jpeg" #fileLogotipoP (change)="uploadLogoP($event)" type="file" name="logo-input" hidden>
                                                    </div>

                                                    <div class="col-sm-12 col-md-12 col-lg-9">
                                                        <label>Nombre</label>
                                                        <input type="text" class="form-control input-style" placeholder="Nombre" formControlName="nombreProyecto" />
                                                        <br>
                                                        <label>Descripción del proyecto</label>
                                                        <textarea #myTextarea class="form-control input-style" placeholder="Ingresa una descripción del proyecto" formControlName="descripcionProyecto" rows="2" style="resize: none;">
                                                        </textarea>
                                                    </div>

                                                    <div class="col-12 pt-3">
                                                        <label>Portada del proyecto <i (click)="info(infoModal,1)"
                                                                class="glyph-icon simple-icon-question"
                                                                style="font-size: 11px; cursor: pointer;"></i></label>

                                                        <div *ngIf="!existeBanner" (click)="fileBanner.click()" class="banner-click">
                                                            <div class="icon-container">
                                                                <i style="font-size: 20px;" class="simple-icon-picture"></i>
                                                            </div>
                                                        </div>



                                                        <div *ngIf="existeBanner" class="contenedor-banner">
                                                            <img class="banner-img pl-1" [src]="bannerUrl" alt="logo">
                                                            <i class="fas fa-times delete-icon" (click)="clearBanner()"></i>
                                                        </div>
                                                        <input accept="image/png, image/jpg, image/jpeg" #fileBanner (change)="uploadBanner($event)" type="file" name="logo-input" hidden>
                                                    </div>

                                                    <div class="col-12 pt-3">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-12 col-lg-3">
                                                                <label for="inputInventario">Tipo de proyecto <i
                                                                        (click)="info(infoModal,2)"
                                                                        class="glyph-icon simple-icon-question"
                                                                        style="font-size: 11px; cursor: pointer;"></i></label>
                                                                <ng-select #ngSelectComponent placeholder="Elige un tipo de proyecto" [multiple]="false" formControlName="tipoProyecto" [items]="tiposProyecto" bindLabel="tipo" class="input-select">
                                                                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                                                        <span class="ng-value-label">
                                                                            {{item.tipo}}</span>
                                                                    </ng-template>
                                                                    <ng-template ng-option-tmp let-item="item">
                                                                        {{item.tipo}}
                                                                    </ng-template>
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-12 col-lg-3">
                                                                <label for="inputInventario">Tipo de venta <i
                                                                        (click)="info(infoModal,3)"
                                                                        class="glyph-icon simple-icon-question"
                                                                        style="font-size: 11px; cursor: pointer;"></i></label>
                                                                <ng-select #ngSelectComponent placeholder="Elige un tipo de proyecto" [multiple]="false" formControlName="tipoVenta" [items]="tiposVenta" bindLabel="tipo" class="input-select">
                                                                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                                                        <span class="ng-value-label">
                                                                            {{item.tipo}}</span>
                                                                    </ng-template>
                                                                    <ng-template ng-option-tmp let-item="item">
                                                                        {{item.tipo}}
                                                                    </ng-template>
                                                                </ng-select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-12 col-lg-3">
                                                                <label>Fecha de entrega <i
                                                                        class="simple-icon-calendar"></i></label>
                                                                <input type="text" placeholder="" class="form-control input-style" formControlName="tiempoEntrega" bsDatepicker [container]="'html'" [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD-MM-YYYY'}" [minDate]="minDate">
                                                            </div>
                                                            <div class="col-sm-12 col-md-12 col-lg-3">
                                                                <label>Numero de unidades <i (click)="info(infoModal,4)"
                                                                        class="glyph-icon simple-icon-question"
                                                                        style="font-size: 11px; cursor: pointer;"></i></label>
                                                                <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="inventario" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                            <br>
                                            <label>Ubicación</label>
                                            <div class="form-group">
                                                <input placeholder="Busca la dirección" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" class="form-control input-style" #search1 [formControl]="searchControl1">
                                            </div>
                                            <agm-map [latitude]="latitude1" [styles]="mapStyles" [longitude]="longitude1" [scrollwheel]="false" [zoom]="zoom1">
                                                <agm-marker [latitude]="latitude1" [longitude]="longitude1"></agm-marker>
                                            </agm-map>

                                            <!-- cambiar las variables y metodos para que funcione como uno nuevo -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="test-l-3" class="content">
                            <form [formGroup]="formModelo" #formM="ngForm" (ngSubmit)="guardaModelo()" novalidate>

                                <div class="row pt-4">
                                    <div *ngIf="!listaModelos" class="col-md-12 fast fadeIn">
                                        <div class="col-md-8 offset-md-2 col-sm-12">
                                            <h2 style="font-weight: bold;">Datos del modelo</h2>
                                            <button class="btn btn-reda btn-sm mb-1 ml-auto fixed-button-m" (click)="agregarModelo()">Modelos</button>
                                            <p>Completa este formulario con los datos específicos del modelo que deseas compartir con nosotros. Entender los detalles de tu modelo nos permitirá analizarlo a fondo y brindarte un enfoque más preciso y adaptado
                                                a tus necesidades y objetivos.</p>
                                            <br>
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-lg-3">
                                                    <label>Render del modelo</label>

                                                    <div *ngIf="!existeImagenM" (click)="fileImagenM.click()" class="container-click">
                                                        <div class="icon-container">
                                                            <i style="font-size: 20px;" class="simple-icon-picture"></i>
                                                        </div>
                                                    </div>



                                                    <div *ngIf="existeImagenM" class="contenedor-img">
                                                        <img class="logo-img pl-1" [src]="modeloUrl" alt="logo">
                                                        <i class="fas fa-times delete-icon" (click)="clearImagenM()"></i>
                                                    </div>
                                                    <input accept="image/png, image/jpg, image/jpeg" #fileImagenM (change)="uploadImagenM($event)" type="file" name="logo-input" hidden>
                                                </div>

                                                <div class="col-sm-12 col-md-12 col-lg-9">
                                                    <label>Nombre</label>
                                                    <input type="text" class="form-control input-style" placeholder="Nombre" formControlName="nombre" />
                                                    <br>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <label>Precio</label>
                                                            <input type="text" class="form-control input-style" placeholder="0" min="0" formControlName="precioModelo" (ngModelChange)="precioModelo=$event" value="{{precioModelo | numberPipe}}" />
                                                        </div>
                                                        <div class="col-6">
                                                            <label>Metros del terreno (m²)</label>
                                                            <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="areas" />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="form-group pt-3">
                                                <label>Recorrido virtual (url)</label>
                                                <input type="text" class="form-control input-style" placeholder="https//recorrido-virtual.com/proyecto" formControlName="recorrido" />
                                            </div>
                                            <div class="form-group pt-3">

                                                <div class="row">
                                                    <div class="col-4">
                                                        <label>Recámaras</label>
                                                        <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="recamaras" />
                                                    </div>
                                                    <div class="col-4">
                                                        <label>Baños</label>
                                                        <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="banos" />
                                                    </div>
                                                    <div class="col-4">
                                                        <label>Estacionamientos</label>
                                                        <input type="number" class="form-control input-style" placeholder="0" min="0" formControlName="estacionamientos" />
                                                    </div>
                                                </div>
                                            </div>




                                        </div>
                                    </div>

                                    <div *ngIf="listaModelos" class="col-md-12 fast fadeIn">

                                        <div class="col-md-8 offset-md-2 col-sm-12">

                                            <h2 style="font-weight: bold;">Modelos del proyecto</h2>
                                            <button *ngIf="modelos.length > 0" class="btn btn-reda btn-sm mb-1 ml-auto fixed-button-m" (click)="agregarModelo()">Agregar modelo</button>


                                            <p>Proporciona detalles sobre los diferentes modelos involucrados en tu proyecto. Entender cómo se estructura y opera tu proyecto nos permitirá brindarte una asistencia más enfocada y personalizada, asegurando
                                                su éxito a lo largo de todo el proceso.</p>
                                            <br>
                                            <div *ngIf="modelos.length == 0" class="text-center">
                                                <img src="../../../assets/img/AgregarModelo.png" alt="">
                                                <br>
                                                <h2 style="font-size: 18px; color: rgba(128, 128, 128, 0.54); font-weight: bold;">
                                                    Sin modelos registrados</h2>
                                                <br>
                                                <br>
                                                <button class="btn btn-reda btn-sm mb-1" (click)="agregarModelo()">
                                                    Agregar modelo</button>
                                            </div>

                                            <div *ngIf="modelos.length > 0">
                                                <div class="row">
                                                    <div *ngFor="let item of modelos" class="col-lg-4 col-md-6 col-sm-6">
                                                        <div class="card mb-3">


                                                            <img alt="img" src="https://reda.mx/recursos/proyectos-empresa/{{item.idEmpresaAfiliada}}/{{item.idProyecto}}/{{item.idModelo}}/modelo.png" class="img-fluid border-0 border-radius c-pointer" style="margin-top: 10px; margin-left: 10px; margin-right: 10px; width: 93%;     height: 230px;
                                                                    object-fit: cover;">

                                                            <div class="card-body">
                                                                <h5>{{item.nombre}}</h5>
                                                                <p *ngIf="item.precioModelo>0" placement="bottom" class=" descripcion">
                                                                    {{item.precioModelo | decimalFormatPipe }}</p>
                                                                <p *ngIf="item.precioModelo==0" placement="bottom" class=" descripcion">
                                                                    $0</p>
                                                                <div class="row" style="padding-left: 15px;
                                                                    padding-right: 15px;
                                                                    display: flex;
                                                                    justify-content: space-between;">
                                                                    <p *ngIf=" item.recamaras >0" class="text-muted text-small"><i class="fa fa-bed"></i> {{item.recamaras}}
                                                                    </p>
                                                                    <p *ngIf=" item.banos >0" class="text-muted text-small"><i class="fa fa-bath"></i> {{item.banos}}</p>
                                                                    <p *ngIf=" item.estacionamientos >0" class="text-muted text-small"><i class="fa fa-car"></i> {{item.estacionamientos}}
                                                                    </p>
                                                                    <p *ngIf=" item.areas>0" class="text-muted text-small"><i class="iconsminds-full-screen-2"></i> {{item.areas}} m²</p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                        <div id="test-l-4" class="content ">
                            <form [formGroup]="formAmenidad" #formA="ngForm" (ngSubmit)="guardaAmenidad()" novalidate>
                                <div class="row pt-4">
                                    <div *ngIf="!listaAmenidades" class="col-md-12 fast fadeIn">
                                        <div class="row">
                                            <div class="col-md-8 offset-md-2 col-sm-12">
                                                <h2 style="font-weight: bold;">Datos de amenidad</h2>
                                                <button class="btn btn-reda btn-sm mb-1 ml-auto fixed-button-m" (click)="agregarAmenidad()">Amenidades</button>
                                                <p>Proporciona el nombre y una imagen para cada amenidad que deseas agregar. Esta información nos ayudará a presentar de manera atractiva las amenidades que ofrece el proyecto y mejorar la experiencia de quienes
                                                    lo conocen.</p>
                                                <br>
                                                <div class="col-md-6 offset-md-3 text-center pt-3">
                                                    <label>Selecciona una:</label>
                                                    <ng-select style="width: 100%;" #ngSelectComponent placeholder="Seleccióna una amenidad" [multiple]="false" formControlName="amenidadSelect" [items]="amenidadesCatalogo" bindLabel="descripcionRespuesta">
                                                        <ng-template ng-label-tmp let-item=" item" let-clear="clear">
                                                            <span class="ng-value-label"><img
                                                                    class="img-thumbnail border-1  align-self-center xsmall"
                                                                    style="width: 20px !important; height: 20px; object-fit: contain;"
                                                                    src="https://www.reda.mx/recursos/iconos-amenidades/{{item.idRespuestaHija}}.png">
                                                                {{item.descripcionRespuesta}}</span>
                                                        </ng-template>
                                                        <ng-template ng-option-tmp let-item="item"><img class="img-thumbnail border-1  align-self-center xsmall" style="width: 20px !important; height: 20px; object-fit: contain;" src="https://www.reda.mx/recursos/iconos-amenidades/{{item.idRespuestaHija}}.png">                                                            {{item.descripcionRespuesta}}
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="listaAmenidades" class="col-md-12 fast fadeIn">
                                        <div class="row">
                                            <div class="col-md-8 offset-md-2 col-sm-12">
                                                <h2 style="font-weight: bold;">Amenidades del proyecto</h2>
                                                <button *ngIf="amenidades.length > 0" class="btn btn-reda btn-sm mb-1 ml-auto fixed-button-m" (click)="agregarAmenidad()">Agregar amenidad</button>
                                                <p>Comparte información sobre las amenidades y características especiales que ofrece tu proyecto. Conocer las amenidades permitirá resaltar los aspectos únicos de tu desarrollo y proporcionar una experiencia
                                                    más enriquecedora para quienes formen parte de él.</p>
                                                <br>
                                                <div *ngIf="amenidades.length == 0" class="text-center">
                                                    <img src="../../../assets/img/AgregarAmenidad.png" alt="">
                                                    <br>
                                                    <h2 style="font-size: 18px; color: rgba(128, 128, 128, 0.54); font-weight: bold;">
                                                        Sin amenidades registradas</h2>
                                                    <br>
                                                    <br>
                                                    <button class="btn btn-reda btn-sm mb-1" (click)="agregarAmenidad()"> Agregar amenidad</button>
                                                </div>

                                                <div *ngIf="amenidades.length > 0">
                                                    <div class="row">
                                                        <div *ngFor="let item of amenidades" class="col-lg-4 col-md-6 col-sm-6">
                                                            <div class="card mb-3">
                                                                <!-- https://reda.mx/recursos/proyectos-empresa/{{item.idEmpresaAfiliada}}/{{item.idProyecto}}/{{item.idModelo}}/modelo.png -->
                                                                <img alt="img" src="https://www.reda.mx/recursos/iconos-amenidades/{{item.idIcono}}.png" class="img-fluid border-0 border-radius c-pointer" style="margin-top: 10px; margin-left: 10px; margin-right: 10px; width: 93%;     height: 230px;
                                                                    object-fit: cover;">
                                                                <div class="card-body">
                                                                    <h5>{{item.nombre}}</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>



                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12 text-center pt-2">
                    <div class="row" style="justify-content: right;">
                        <p (click)="tyc()" class="fixed-tyc pr-3">Términos y condiciones</p>
                        <p>|</p>
                        <p (click)="ayuda()" class="fixed-tyc pl-3">¿Necesitas ayuda?</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!step0">
        <button *ngIf="!guardando" class="fixed-button" [disabled]="!formU.form.valid" (click)="formU.ngSubmit.emit()">Continuar</button>
        <button *ngIf="guardando" class="fixed-button" disabled>Guardando <i style="color: white; width: 20px;"
                class="fa-solid fa-spinner fa-spin"></i></button>
    </div>

    <div *ngIf="!step1 && step0">
        <button *ngIf="!guardando" class="fixed-button" [disabled]="!formD.form.valid" (click)="formD.ngSubmit.emit()">Continuar</button>
        <button *ngIf="guardando" class="fixed-button" disabled>Guardando <i style="color: white; width: 20px;"
                class="fa-solid fa-spinner fa-spin"></i></button>
    </div>

    <div *ngIf="!step2 && step1">
        <button *ngIf="!guardando" class="fixed-button" [disabled]="!formP.form.valid" (click)="formP.ngSubmit.emit()">Continuar</button>
        <button *ngIf="guardando" class="fixed-button" disabled>Guardando <i style="color: white; width: 20px;"
                class="fa-solid fa-spinner fa-spin"></i></button>
    </div>

    <div *ngIf="tabModelos">
        <button *ngIf="!guardando && !listaModelos" class="fixed-button" [disabled]="!formM.form.valid" (click)="formM.ngSubmit.emit()">Guardar modelo</button>
        <button *ngIf="modelos.length>0 && listaModelos" class="fixed-button" (click)="next()">Continuar</button>
        <button *ngIf="guardando" class="fixed-button" disabled>Guardando <i style="color: white; width: 20px;"
                class="fa-solid fa-spinner fa-spin"></i></button>
    </div>



    <div *ngIf="tabAmenidades">
        <button *ngIf="listaAmenidades && omitir" class="fixed-button" (click)="omitirAmenidades()">Omitir</button>

        <button *ngIf="!guardando && !listaAmenidades" class="fixed-button" [disabled]="!formA.form.valid" (click)="formA.ngSubmit.emit()">Guardar amenidad</button>
        <button *ngIf="(amenidades.length>0 && !guardando && listaAmenidades) || sinAmenidades" class="fixed-button-a" (click)="terminar(modalFin)">Enviar
            proyecto a revisión</button>
        <button *ngIf="guardando" class="fixed-button" disabled>Guardando <i style="color: white; width: 20px;"
                class="fa-solid fa-spinner fa-spin"></i></button>
    </div>


</div>





<!-- <div class="elementor-element elementor-element-fdda217 iteck-image-animation-wave elementor-absolute elementor-widget elementor-widget-iteck-image" data-id="fdda217" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}"
    data-widget_type="iteck-image.default">
    <div class="elementor-widget-container">

        <div class="iteck-image">

            <img decoding="async" src="https://iteck.themescamp.com/app/wp-content/uploads/sites/3/2022/04/header_4_wave.png" title="" alt="" loading="lazy">
        </div>

    </div>
</div> -->
<ng-template #modalFin>
    <div role="document" class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-left font-weight-bold my-component">¿Que datos se enviarán a <span style=" color:#7dbd4d;">revisión</span>?</h4><button (click)="modalRef.hide() " type="button " aria-label="Close " class="close pull-right "><span aria-hidden="true ">×</span></button>
            </div>
            <div class="modal-body ">
                <p>Revisaremos los siguientes datos de tu empresa y proyecto. Pronto nos pondremos en contacto con usted.
                </p>

                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <p style="font-weight: bold; font-size: 16px;">Empresa</p>

                        <div class="d-flex flex-row pb-2 border-bottom ng-star-inserted">
                            <a href="javascript:;"><img style="width: 50px; height: 50px;" class="img-thumbnail border-0 rounded-circle list-thumbnail align-self-center xsmall" src="https://www.reda.mx/recursos/logos/{{empresaSubmit.idEmpresaAfiliada}}/logo.png" alt="img"></a>
                            <div class="col-6">
                                <div class="pl-3 pr-2">
                                    <a href="javascript:;">
                                        <p class="font-weight-bold mb-0">{{empresaSubmit.nombre}}</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <p style="font-weight: bold; font-size: 16px;">Proyecto</p>

                        <div class="d-flex flex-row border-bottom ng-star-inserted">
                            <a href="javascript:;"><img style="width: 50px; height: 50px;" class="img-thumbnail border-0 rounded-circle list-thumbnail align-self-center xsmall" src="https://www.reda.mx/recursos/proyectos-empresa/{{proyectoSubmit.idEmpresaAfiliada}}/{{proyectoSubmit.idProyecto}}/proyecto.png"
                                    alt="img"></a>
                            <div class="col-6">
                                <div class="pl-3 pr-2">
                                    <a href="javascript:;">
                                        <p class="font-weight-bold mb-0">{{proyectoSubmit.nombre}}</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                <p class="pt-3" style="font-weight: bold; font-size: 16px;">Modelos</p>

                <div class="row">
                    <div *ngFor="let item of modelos" class="col-3">
                        <div class="text-center"> <img style="border-radius: 100%;" width="50px" height="50px" src="https://www.reda.mx/recursos/proyectos-empresa/{{item.idEmpresaAfiliada}}/{{proyectoSubmit.idProyecto}}/{{item.idModelo}}/modelo.png">
                            <p class="card-text font-weight-semibold mb-0"> {{item.nombre}} </p>
                        </div>
                    </div>
                </div>

                <p *ngIf="amenidades.length  > 0 " class="pt-3" style="font-weight: bold; font-size: 16px;">Amenidades
                </p>

                <div class="row">
                    <div *ngFor="let item of amenidades" class="col-3">
                        <div class="text-center">
                            <p class="card-text font-weight-semibold mb-0"> {{item.nombre}} </p>
                        </div>
                    </div>
                </div>

                <br>
                <p>Cualquier duda, aclaración o modificación sera resuelta cuando aprovemos tu proyecto y nos pongamos en contacto con usted.</p>
                <div class="row pb-5 pl-2 pt-2" style="display: flex; align-items: center; justify-content: center;">
                    <input type="checkbox" class="pr-2" (change)="acpetaTyC($event)">
                    <a (click)="tyc()" style="padding-left: 10px;" href="javascript:;">
                        <p class="font-weight-bold mb-0">Acepto los <span style=" color:#7dbd4d; ">términos y
                                condiciones</span></p>
                    </a>
                </div>
                <button *ngIf="!guardando" [disabled]="!tycAceptar" (click)="enviarCorreo()" type="button" class="btn btn-success btn-reda mb-1 mr-2 float-center font-weight-bold">Enviar proyecto</button>
                <button *ngIf="guardando" class="fixed-button-info" disabled>Enviando <i
                        style="color: white; width: 20px;" class="fa-solid fa-spinner fa-spin"></i></button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #infoModal>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Información</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalInfoRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <h4 style="font-weight: bold;">{{titulo}}</h4>
        <br>
        <div [innerHtml]="descripcionConSaltosDeLinea"></div>
    </div>

</ng-template>

<ng-template #empresaModal>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Empresa detectada</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefEmpresa.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">

        <div class="d-flex flex-row pb-2 border-bottom ng-star-inserted">
            <a href="javascript:;"><img style="width: 50px; height: 50px;" class="img-thumbnail border-0 rounded-circle list-thumbnail align-self-center xsmall" src="https://www.reda.mx/recursos/logos/{{empresaSubmit.idEmpresaAfiliada}}/logo.png" alt="img"></a>
            <div class="col-6">
                <div class="pl-3 pr-2 pt-2">
                    <a href="javascript:;">
                        <p class="font-weight-bold mb-0">{{empresaSubmit.nombre}}</p>
                    </a>
                </div>
            </div>
        </div>
        <br>
        <p>Tu información ya se encuentra asociada a esta empresa, si es así solo ingresa la información del proyecto que quieres enviar a revisión para que verifiquemos su información. Si crees que se trata de un error ponte en contacto con nosotros.</p>
    </div>

</ng-template>